<template>
  <div class="popuper">
    <Popup
      v-model="getShow" round position="bottom" class="popup"
      :close-on-click-overlay="false"
    >
      <div class="container">
        <div class="header">
          <div class="title">{{isShowTitleType ? '请选择学员' : '点击选择加购学员'}}</div>
          <div class="close" @click="closePop"></div>
        </div>
        <div class="content">
          <div
            v-for="(item, index) in getList"
            :key="index"
            class="item"
            @click="check(item)"
          >
            <div class="name">{{item.realName}}</div>
            <div class="code">{{item.studentCodes[0].studentCode}}</div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
  import { Popup } from 'vant'

  export default {
    name: 'studentPopuper',
    components: {
      Popup
    },
    props: {
      show: {
        type: Boolean
      },
      list: {
        type: Array
      },
      showTitleType: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      show (val) {
        this.getShow = val
      },
      list (val) {
        this.getList = val
      }
    },
    data () {
      return {
        getShow: this.show,
        getList: this.list,
        isShowTitleType: false
      }
    },
    mounted () {
      this.isShowTitleType = this.showTitleType
    },
    methods: {
      check (item) {
        console.log(item, 'item')
        this.$emit('checkedCode', item)
      },
      closePop () {
        this.$emit('closepop')
      }
    }
  }
</script>

<style scoped lang="less">
  .popup {
    max-height: 844px;
    .container {
      max-height: 844px;
      .header {
        width: 100%;
        height: 132px;
        padding: 44px 32px 32px 32px;
        position: relative;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        .title {
          font-size: 40px;
          font-family: 'PingFang-SC-Bold', 'PingFang-SC';
          height: 56px;
          font-weight: bold;
          color: #1e1e1e;
        }
        .close {
          position: absolute;
          right: 32px;
          top: 50px;
          width: 32px;
          height: 32px;
          background: url(../assets/nav_icon_close@2x.png) no-repeat;
          background-size: cover;
        }
      }
      .content {
        width: 100%;
        max-height: 712px;
        overflow-y: scroll;
        .item {
          width: 686px;
          height: 142px;
          background: #fff;
          margin: 0 auto;
          margin-bottom: 32px;
          box-shadow: 0px 2px 16px 0px rgba(206, 223, 241, 0.2);
          border-radius: 20px;
          border: 2px solid rgba(237, 240, 247, 0.7);
          display: flex;
          align-items: center;
          font-size: 30px;

          .name {
            margin-left: 30px;
            font-weight: 500;
            color: #333;
          }
          .code {
            margin-left: 16px;
            font-weight: 400;
            color: #666;
          }
          &:last-child {
            margin-bottom: 40px;
          }
        }
      }
    }
  }
  .van-popup--bottom.van-popup--round {
    border-radius: 20px 20px 0 0;
  }
</style>
